(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoj-way-mooncakes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const groups = document.querySelectorAll('.hoj-way-mooncakes .bubble_section');
    if (!groups.length) return;

    if (!('IntersectionObserver' in window)) {
      groups.forEach(function (group) {
        group.classList.add('in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    groups.forEach(function (group) {
      observer.observe(group);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoj-way"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const groups = document.querySelectorAll('.hoj_way .bubble_section');
    if (!groups.length) return;

    if (!('IntersectionObserver' in window)) {
      groups.forEach(function (group) {
        group.classList.add('in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    groups.forEach(function (group) {
      observer.observe(group);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const columns = document.querySelectorAll('.third_column');
    if (!columns.length) return;

    if (!('IntersectionObserver' in window)) {
      columns.forEach(function (col) {
        col.classList.add('in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    columns.forEach(function (col) {
      observer.observe(col);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.image_with_text_v3');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const groups = document.querySelectorAll('.image_with_text_v4 .bubble_section');
    if (!groups.length) return;

    if (!('IntersectionObserver' in window)) {
      groups.forEach(function (group) {
        group.classList.add('in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    groups.forEach(function (group) {
      observer.observe(group);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v6"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const blobs = document.querySelectorAll('.image_with_text_v6 .yum_cha_right');
    if (!blobs.length) return;

    if (!('IntersectionObserver' in window)) {
      blobs.forEach(function (blob) {
        blob.classList.add('in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    blobs.forEach(function (blob) {
      observer.observe(blob);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
